<script setup lang="ts">
import { computed } from 'vue';
import LearnDocPage from '@/components/learn/LearnDocPage.vue';
import LearnDocsShell from '@/components/learn/LearnDocsShell.vue';

const route = useRoute();
const slug = computed(() => String(route.params.slug || 'welcome'));
</script>

<template>
  <LearnDocsShell>
    <LearnDocPage :slug="slug" />
  </LearnDocsShell>
</template>
